import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";
import { useTranslate } from "@tolgee/react";

const ApproveTwoFactor = React.lazy(() => import("./ApproveTwoFactor"));

function ApproveTwoFactorPage(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "approve.two-factor.document-title",
      defaultValue: "Smart Portal - Approve Two Factor",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "approve.widget.loading", defaultValue: "Loading CTM Approve" })}
        />
      }
    >
      <ApproveTwoFactor {...props} />
    </Suspense>
  );
}

export default ApproveTwoFactorPage;
